function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#348CC1",
  fillRule: "evenodd",
  d: "M.732 20H0V0h.732v20zm1.463 0h-.732V0h.732v20zm1.464 0h-.732V0h.732v20zm2.926 0h-.731V0h.731v20zm2.195 0H8.05V0h.731v20zm2.196 0h-.732V0h.732v20zm1.463 0h-.732V0h.732v20zm.732 0h-.732V0h.732v20zm2.195 0h-.732V0h.732v20zm2.927 0h-.732V0h.732v20zm2.195 0h-.732V0h.732v20zm2.195 0h-.732V0h.732v20zm1.463 0h-.731V0h.731v20zm2.927 0H25.61V0h1.463v20zm1.464 0h-.732V0h.732v20zM30 20h-.732V0H30v20z"
});

function SvgBankSlip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankSlip);
export default __webpack_public_path__ + "static/media/bank-slip.35b5536b.svg";
export { ForwardRef as ReactComponent };